/**
 * @fileoverview PUT handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/creative_variants/dimensions/:dimension/actions/:action_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { putDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionActionsActionIdCacheKeys } from "./constants";
import type {
  PutDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionActionsActionIdProps,
  PutDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionActionsActionIdResult,
} from "./types";

export const putDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionActionsActionId =
  reactQueryMutationAdapter(
    putDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionActionsActionIdCacheKeys,
    (
      props: PutDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionActionsActionIdProps
    ): Promise<PutDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionActionsActionIdResult> => {
      return fetch(
        `/decisioning_studio_agents/${props.appGroupId}/${props.dsaId}/creative_variants/dimensions/${props.dimension}/actions/${props.actionId}`,
        "PUT",
        {
          creative: props.creative,
          base_creative_campaign_ids: props.base_creative_campaign_ids,
          write_mode: props.write_mode,
        },
        undefined,
        { propagateFetchRequestError: false }
      );
    }
  );
